import React from "react";
import StandAloneComplaintMasterLayout from "../masterLayout/StandAloneComplaintMasterLayout";
import ComplainantFeedbackForm from "../components/ComplainantFeedbackForm";
import { Breadcrumb } from "react-bootstrap";

const ComplainantFeedbackFormPage = () => {
  return (
    <React.Fragment>
      <StandAloneComplaintMasterLayout>
        <Breadcrumb title="Complaint Management System" />
        <ComplainantFeedbackForm />
      </StandAloneComplaintMasterLayout>
    </React.Fragment>
  );
};

export default ComplainantFeedbackFormPage;
